import ProxyButton from '../../components/common/ProxyButton';
import BaseMfaVerifyCustomizer from './base';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../constants';

export default class ChallengePollCustomizer extends BaseMfaVerifyCustomizer {

  primaryButtonClassName = 'fe_u_margin--bottom-small';
  async shouldCustomize() {
    return this.context.controller === 'mfa-verify' && this.context.formName === 'challenge-poll';
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
    super.forgifyController();
    this.forgifyOktaPushButton();
  }

  private forgifyOktaPushButton() {
    const oktaNextButton: JQuery<HTMLElement> = jQueryCourage('.link-button');
    const isDisabled = oktaNextButton.hasClass('link-button-disabled');

    if (oktaNextButton.length) {
      const forgeComponent = (
        <ProxyButton
          oktaButton={oktaNextButton}
          variant="primary"
          size='large'
          disabled={isDisabled}
          fullWidth={true}
          className='fe_u_margin--bottom-small'
        />
      );
      this.renderForgeAndHideOktaComponent({
        id: oktaNextButton.attr('class')!,
        oktaComponent: oktaNextButton,
        forgeComponent: forgeComponent,
      });
    }
  }
}
